import { onMounted, ref } from '@vue/composition-api';
import { getMyCouponCount, getMyWePointsCount } from './api';
import { CustomException } from '@tencent/ppd-base-libs';

/**
 * 用户资产(优惠券、积分)模块
 */
export function useUserAssetsCount() {
  const isReady = ref(false);
  const assetsCountData = ref({
    couponCount: 0,
    wepointsCount: 0,
  });
  const initCouponCount = async () => {
    assetsCountData.value.couponCount = await getMyCouponCount();
  };
  const initWePointsCount = async () => {
    assetsCountData.value.wepointsCount = await getMyWePointsCount();
  };
  /** 初始化资产数据 */
  const initAssetsData = async () => {
    const results = await Promise.allSettled([
      initCouponCount(),
      initWePointsCount(),
    ]);
    isReady.value = true;
    const hasFailResult = results.some(result => result.status === 'rejected');
    if (hasFailResult) {
      new CustomException(undefined, 'InitUserAssetsDataFail', '获取用户奖品数据失败');
    }
  };
  onMounted(() => {
    initAssetsData();
  });
  return {
    isReady,
    assetsCountData,
  };
}
